module.exports = {"id":"198331","name":"Matěj Vydra","rating":"73","photo":"./data/images/photos/3/198331.png","club":{"name":"Derby County","logo":"./data/images/clubs/DerbyCounty.png"},"positions":["MOC","ATT","BU","AG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MatejVydra0.json
// module id = 2850
// module chunks = 0